
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import { InventorySummaryListItem } from "@/models/api/barcodeSystem/inventory/summary";

const inventoryModuleState = getModule(InventoryModule);

import draggable from "vuedraggable";

import RightClickMenu from "@/components/widgets/RightClickMenu.vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({
  components: {
    RightClickMenu,
    draggable
  }
})
export default class InventorySummaryTable extends Vue {
  @Prop({ default: "table" })
  public id: string;

  @Prop({ default: "" })
  public containerClass: string;

  @Prop({ default: null })
  public tableField: Array<any>;

  @Prop({ default: null })
  public tableMenuItem: Array<any>;

  public rightClickLocation: any = null;
  public showHelp: boolean = false;
  public draggingData: boolean = false;

  get filterFields() {
    let filterFields = this.tableField.filter(
      field => field.hidden === false && field.key !== "selected"
    );
    return filterFields;
  }

  set filterFields(newValue) {
    this.$emit("updateFields", newValue);
  }

  get inventorySummary(): Array<InventorySummaryListItem> {
    return inventoryModuleState.summaryData;
  }

  get loading(): boolean {
    return inventoryModuleState.loading;
  }

  get selectedSummaryItemCount(): number {
    return inventoryModuleState.getSelectedSummaryItemCount;
  }

  get selectedSummaryItems(): Array<any> {
    return inventoryModuleState.getSelectedSummaryItems;
  }

  
  get totalItems() {
    if (inventoryModuleState.summaryPageData) {
      const items = inventoryModuleState.summaryPageData.totalItems;
      return items ? items : 0;
    } else {
      return 0;
    }
  }

  
  get currentSortAscending() {
    return inventoryModuleState.summaryDataSortAscending;
  }
  get currentSort() {
    return inventoryModuleState.summaryDataSortKey;
  }

  unselectAll() {
    let summaryItems = this.selectedSummaryItems;

    summaryItems.forEach(summary => {
      inventoryModuleState.switchSummarySelectionStatus(summary.id);
    });
  }

  getComponentData(rowData) {
    return {
      on: {
        click: () => this.onRowClick(rowData),
        contextmenu: $event => this.onRightClicked(rowData, $event),
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }
  canMove() {
    return false;
  }
  putFeature() {
    return false;
  }
  sort(s) {
    this.$emit("sort", s);
  }

  onRightClicked(rowData, event) {
    event.preventDefault();
    if (!rowData.selected) inventoryModuleState.switchSummarySelectionStatus(rowData.id);

    this.rightClickLocation = { x: event.x, y: event.y };
  }
  onDoubleClicked(summaryData) {
    let summaryId = summaryData.id;
    //this.$router.push(`/trucks/${truckNumber}`);
  }
  onRowClick(rowData) {
    inventoryModuleState.switchSummarySelectionStatus(rowData.id);

    this.clearRightClick();
  }
  clearRightClick() {
    this.rightClickLocation = null;
    this.draggingData = false;
  }
  clickMenu(item) {
    let summaryItems = this.selectedSummaryItems;
    this.$store.dispatch(item.action, { selectedItems: summaryItems });
    this.clearRightClick();
  }
  onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
    if (
      Math.ceil(scrollTop) + 1 + clientHeight >= scrollHeight &&
      !this.loading &&
      inventoryModuleState.summaryPageData.totalItems > this.inventorySummary.length
    ) {
      this.$emit("loadMoreData");
    }
  }

  getFieldClass(field, summaryData) {
    var fieldClass = null;
    if (field.textAlign) {
      switch (field.textAlign) {
        case "right":
          fieldClass = "text-right";
          break;
        case "left":
          fieldClass = "text-left";
          break;
        case "center":
          fieldClass = "text-center";
          break;
        default:
          break;
      }
    }

    if(field.noWrap)
    {
      fieldClass += " text-nowrap";
    }

    return fieldClass;
  }

  getValue(object, path) {
    if (!path) return;
    return path.split(".").reduce((r, k) => (r ? r[k] : ""), object);
  }
}
